import StyledBrainButtons, { StyledButton } from "./StyledBrainButtons";
import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";

import { Link } from "react-router-dom";
import { debounce } from "lodash";
import { delay } from "lodash";
import { getProductGroups } from "../../services/homeRequestServices";
import { whereIsPointOnContainer } from "../../utilities/coordinatesOnBrain";

const Information = ({
  title,
  symbol,
  description,
  link,
  containerDimensions,
  changeSelectedData,
}) => {
  const [isShowData, toggleIsShowData] = useState(false);
  const [badgeCoordinates, changeBadgeCoordinates] = useState(() => ({
    root: {},
    before: {},
  }));
  const btnRef = useRef();
  const linkRef = useRef();

  const handleShowData = () => {
    changeSelectedData({ title, symbol, description, link });
    toggleIsShowData(true);
  };

  const resizeWindow = useCallback(
    debounce(() => {
      const btnDimensions = btnRef.current?.getBoundingClientRect();
      if (containerDimensions && btnDimensions) {
        changeBadgeCoordinates(
          whereIsPointOnContainer(containerDimensions, btnDimensions)
        );
      }
    }, 100),
    []
    // [containerDimensions] this code make a bug !! not use
  );

  useLayoutEffect(() => {
    resizeWindow();
    console.log("test run brain component");
    const handleResize = () => {
      resizeWindow();
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [resizeWindow]);

  useEffect(() => {
    if (isShowData && linkRef.current) {
      linkRef.current.focus();
    }
    if (!isShowData) {
      changeSelectedData(null);
    }
  }, [isShowData, changeSelectedData]);
  return (
    <StyledButton
      className={`absolute-button ${
        isShowData && window.innerWidth <= 768 ? "is-show_for__mobile" : ""
      }`}
      onClick={handleShowData}
      onFocus={handleShowData}
      coordinates={badgeCoordinates}
      ref={btnRef}
    >
      {window.innerWidth > 768 && (
        <div className={`absolute-button_info`}>
          <div
            className={`d-none d-md-flex align-items-center justify-content-center h-100 ${
              isShowData ? "text-white" : "text-green"
            }`}
          >
            {symbol}
          </div>
        </div>
      )}

      {window.innerWidth <= 768 && (
        <div className="absolute-button_info text-12">
          <div className="text-end" dir="rtl">
            <div className="mb-3">
              {title} ({symbol})
            </div>
            <div className="information_button__description">{description}</div>
            <div className="text-start w-100 mt-3 px-2">
              <Link to={link} className="text-green text-12">
                بیشتر
              </Link>
            </div>
          </div>
        </div>
      )}
      <Link
        to="/"
        ref={linkRef}
        className="float-end text-green"
        onBlur={({ relatedTarget }) => {
          if (
            relatedTarget === null ||
            !relatedTarget.classList.contains("dont-skip")
          )
            toggleIsShowData(false);
        }}
      />
    </StyledButton>
  );
};

const BrainButtons = ({ onMounted }) => {
  const brainContainer = useRef(null);
  const [containerDimensions, changeDimensions] = useState(null);
  const [productList, changeProductList] = useState([]);
  const [selectedData, changeSelectedData] = useState(null);

  const getProductList = useMemo(() => {
    return () => {
      return getProductGroups().then(({ results }) =>
        changeProductList(
          results.map((item) => ({
            key: item.id,
            title: item.title,
            symbol: item.latin_title,
            description: item.description,
            link: "/products/",
          }))
        )
      );
    };
  }, []);

  useEffect(getProductList, [getProductList]);

  const resizeWindow = useMemo(() => {
    return debounce(() => {
      if (brainContainer.current) {
        const { bottom, height, left, right, top, width, x, y } =
          brainContainer.current.getBoundingClientRect();
        changeDimensions({ bottom, height, left, right, top, width, x, y });
      }
    }, 100);
  }, []);

  useEffect(() => {
    const callbackFunction = (entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        resizeWindow();
        delay(() => onMounted(), 300);
      }
    };
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };
    let observerRefValue = null;
    let observer = new IntersectionObserver(callbackFunction, options);
    if (brainContainer.current) {
      observer.observe(brainContainer.current);
      observerRefValue = brainContainer.current;
    }
    return () => {
      if (observerRefValue) {
        observer.unobserve(observerRefValue);
      }
    };
  }, [onMounted, resizeWindow]);

  return (
    <StyledBrainButtons ref={brainContainer}>
      {brainContainer?.current && (
        <div className="nth">
          {productList.map((item) => (
            <Information
              key={item.key}
              title={item.title}
              symbol={item.symbol}
              description={item.description}
              link={item.link}
              changeSelectedData={changeSelectedData}
              containerDimensions={containerDimensions}
              brainContainer={brainContainer}
            />
          ))}

          {selectedData && window.innerWidth > 768 && (
            <div className="brain-button_show_info text-12">
              <div className="text-end" dir="rtl">
                <div className="mb-3 text-green font-weight-600">
                  {selectedData.title} ({selectedData.symbol})
                </div>
                <div className="information_button__description">
                  {selectedData.description}
                </div>
                <div className="text-end w-100 mt-3 px-2">
                  <Link
                    to="/"
                    className="text-green text-12 information_button__close"
                    onClick={() => changeSelectedData(null)}
                  >
                    <span className="icon-close-outline"></span>
                  </Link>
                  <Link
                    to={selectedData.link}
                    className="text-green text-12 dont-skip"
                  >
                    بیشتر بدانید
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </StyledBrainButtons>
  );
};
export default BrainButtons;
